import Chart from 'chart.js/auto';
import {AlgoBase} from "./AlgoBase";

export class Aquilon1ChartJS extends AlgoBase {

  constructor(target) {
    super("aquilon", target);
    this.init();
  }

  async init() {

    this.algortihmData = await this.buildDataset("data/algorithms/Aquilon1.csv");

    const ctx = this.$widget.find("canvas");

    this.chart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: this.algortihmData.labels,
        datasets: [{
          label: 'OAT Weather Service',  // [dynamic value in loadDataset()],
          borderColor: '#E62B33',
          data: this.algortihmData.mainDatasets[0],
        }, {
          label: 'OAT Local Sensor', // [dynamic value in loadDataset()],
          borderColor: '#000000',
          data: this.algortihmData.sensorDatasets[0],
        }, {
          label: 'Damper', // [dynamic value in loadDataset()],
          borderColor: '#6400FF',
          data: this.algortihmData.damperDatasets[0],
          yAxisID: 'yRight',
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          annotation: {
            annotations: {
              line1: {
                type: 'line',
                title: 'Econ Enable Temp', // [dynamic value in loadDataset()],
                borderColor: '#6400FF', // Line color
                borderWidth: 1,
                borderDash: [4, 4],
                drawTime: 'beforeDraw',
                yMin: 0,
                yMax: 0,
                z: 1,
              },
            }
          },
          legend: {
            labels: {
              filter: function(item, chartData) {
                return !item.hidden
              }
            }
          },
          title: {
            display: true,
            text: 'OAT', // [dynamic value in loadDataset()],
          },
          subtitle: {
            display: true,
            text: 'Damper position'
          }
        },
        elements: {
          line: {
            tension: 0.3,
            borderColor: '#330808',
          }
        },
        scales: {
          x: this.setupXAxis(this.algortihmData.labels.length / 6),
          y: {
            // min: [dynamic value in loadDataset()],
            // max: [dynamic value in loadDataset()],
            ticks: {
              callback: (value, index, ticks) => {
                return this.temperatureLegend(value); // Append the unit
              }
            },
          },
          yRight: {
            position: 'right',
            min: 0,
            max: 100,
            grid: {drawOnChartArea: false},
            ticks: {
              callback: (value, index, ticks) => {
                return value + ' %';
              }
            },
          }
        }
      }
    });

    this.loadDataset(0)

    this.initEvents();

    this.ready();
  }

  setPreferredLanguage(preferredLanguage) {
    this.chart.options.plugins.legend.labels.padding = (preferredLanguage === "fr") ? 18 : Chart.defaults.plugins.legend.labels.padding;
    super.setPreferredLanguage(preferredLanguage);
  }

  loadDataset(datasetIndex) {
    const offset = (this.aiEnabled ? 0 : this.getLoopIndex());

    // Update data for preferred unit
    this.algortihmData.mainDatasets[datasetIndex + offset] = this.convertDatasetToPreferredUnit(this.algortihmData.allDatasets[0][datasetIndex + offset])
    this.chart.data.datasets[1].data = this.convertDatasetToPreferredUnit(this.algortihmData.allDatasets[1][datasetIndex + offset]);
    this.chart.data.datasets[2].data = this.algortihmData.damperDatasets[datasetIndex + offset];

    // Update dynamic strings from CMS
    this.chart.data.datasets[0].label = this.getLegendFromCMS(1, 1);
    this.chart.data.datasets[1].label = this.getLegendFromCMS(2, 1);
    this.chart.data.datasets[2].label = this.getLegendFromCMS(3, 1);
    this.chart.options.plugins.annotation.annotations.line1.title = this.getLegendFromCMS(4, 1);

    // Update y limits for preferred unit
    if (this.preferredUnit === "celsius") {
      this.chart.options.scales.y.min = 10
      this.chart.options.scales.y.max = 40
    } else {
      this.chart.options.scales.y.min = 50
      this.chart.options.scales.y.max = 105
    }

    let lineY = (this.aiEnabled) ? 70 : 65;
    if (this.preferredUnit === "celsius") lineY = this.fahrenheitToCelsius(lineY)
    this.chart.options.plugins.annotation.annotations.line1.yMin = lineY;
    this.chart.options.plugins.annotation.annotations.line1.yMax = lineY;

    this.chart.setDatasetVisibility(1, !this.aiEnabled);

    this.chart.options.plugins.title.text = this.getLegendFromCMS(5, 1)?.toUpperCase();
    this.chart.options.plugins.subtitle.text = this.getLegendFromCMS(6, 1)?.toUpperCase();

    super.loadDataset(datasetIndex);
  }

  async buildDataset(filename) {
    const singleDataSetBuild = await super.buildDatasetFromCSV(filename, 3);
    return {
      labels: singleDataSetBuild.labels,
      allDatasets: singleDataSetBuild.allDatasets,
      mainDatasets: [...singleDataSetBuild.allDatasets[0]],
      sensorDatasets: [...singleDataSetBuild.allDatasets[1]],
      damperDatasets: [...singleDataSetBuild.allDatasets[2]]
    };
  }

}
